import {
  DeviceInfoEntity,
} from './deviceInfoEntity';
import { Language } from './valueObjects/language';
import { UserAgent } from './valueObjects/userAgent';

import type {
  DeviceInfoProps,
} from './deviceInfoEntity';
import type { DeviceInfoJson } from '@/types/domain/device/entities/deviceInfoEntity';

import { Factory } from '@/domain/factory';

/**
 * デバイス情報ファクトリ
 */
export class DeviceInfoFactory extends Factory<
  DeviceInfoEntity,
  DeviceInfoProps,
  DeviceInfoJson
> {
  /**
   * window.navigatorより生成する
   * @returns デバイス情報Entity
   */
  public createFromWindowNavigator(): DeviceInfoEntity {
    const {
      userAgent,
      language,
    } = window.navigator;
    return this.createFromJsonPvt({
      userAgent,
      language,
    });
  }

  /**
   * 比較
   * @param a 対象1
   * @param b 対象2
   * @returns 差分
   */
  comparePvt = (a: DeviceInfoJson, b: DeviceInfoJson) => a.userAgent.localeCompare(b.userAgent, 'en');

  /**
   * Entityを生成する
   * @param props プロパティ
   * @returns Entity
   */
  createPvt(props: DeviceInfoProps): DeviceInfoEntity {
    return new DeviceInfoEntity(props, null);
  }

  /**
   * JsonからEntityを生成する
   * @param props Json
   * @returns Entity
   */
  createFromJsonPvt(props: DeviceInfoJson): DeviceInfoEntity {
    return this.createPvt({
      userAgent: UserAgent.create(props.userAgent),
      language: Language.create(props.language),
    });
  }
}
